import React from 'react';

function MissingValue() {
    return <span className="statusbar-mobile-current-status__dimension-missing">XX</span>;
}

export { MissingValue };